module.exports = __webpack_public_path__ + "static/media/wavylogo.146d6de4.svg";